import API from "../../helpers/apiHelpers";
import { routes } from "../../Constants/api";
import makeFetch from "../../utils/http";

export function api_getUserProfile({userId}) {
    return makeFetch(
        "profiles",
        "GET",
        {userId: userId}
    );
}

export function api_setUserProfile(profile) {
    return makeFetch(
        "profiles",
        "POST",
        {},
        JSON.stringify(profile)
    );
}

export function api_patchUserProfile({id, body}) {
    return makeFetch(
        `profiles/${id}`,
        "PATCH",
        {},
        JSON.stringify(body)
    );
}

export function api_getProfileURLUploadImage(id) {
    return makeFetch(
        `profiles/${id}/upload`,
        "GET"
    );
}

export function api_getAddress(userId) {
    return makeFetch(
        "addresses",
        "GET",
        {userId: userId}
    );
}

export function api_setAddress(body) {
    return makeFetch(
        "addresses",
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_patchAddress(body) {
    return makeFetch(
        "addresses",
        "PATCH",
        {},
        JSON.stringify(body)
    );
}
